<template>
    <div class="content">
        <div class="container" style='padding-top:20px;padding-left:20px;width:auto;'>
                <h1 class="title">常见问题</h1>

                <ul class="accordion">
                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>免费试用时长
                        </h2>
                        <div class="text">
                            <p>都都英语，年卡销售活动火热进行中，<br>
                            新用户注册即可获得7天免费体验机会。<br>
                            7天免费体验时间从注册后启动应用开始起算。<br><br>

                            <strong>免费体验期间内可享受：</strong><br>
                            1. 通过水平测试或自选方式设置课程水平<br>
                            2. 所有内容无限制使用<br>
                            3. 支持多台设备同时使用<br><br><br>

                            <strong>免费体验Tip：</strong><br>
                            1. 使用都都数学的账号可直接登录都都英语<br>
                            2. 免费体验过期，也不会自动扣款或自动延期订阅，请放心使用</p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>找回密码或注册邮箱丢失</h2>
                        <div class="text">
                            <p>
                                <strong>如果您忘记了密码：</strong><br>
                                1.您可以在登陆时点击忘记密码，然后去邮箱查收重置密码邮件，按照提示操作即可<br>
                                2.您也可以直接联系官方客服QQ:2179916770<br><br>

                                <strong>如果您忘记了注册邮箱:</strong><br>
                                请直接联系官方客服QQ:2179916770
                            </p>
                        </div>
                    </li>
                        
                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>同时使用</h2>
                        <div class="text">
                            <p>
                                1个账号可以添加1个孩子的存档。<br>
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>背景音乐等的所有音效没声音</h2>
                        <div class="text">
                            <p>
                                都都英语有很丰富多样的各种音效，<br>
                                如果其中声音听不到， 您可以试试以下几种方式进行确认；<br><br>

                                1. 检查设备是否设置为静音模式<br>
                                2. 调整设备音量<br>
                                3. 都都英语支持音效关闭功能， 请在家长页面确认音效是否打开
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>识别不出孩子说话</h2>
                        <div class="text">
                            <p>
                                请先由家长试试，如果还不能识别， 检查都都数学应用中的麦克风功能是否开启，<br>
                                请参考以下方式确认麦克风功能是否已开启；<br><br>

                                <strong>1. iOS机型：</strong><br>
                                打开手机上的“设置”， 往下拉在“已安装应用列表”中找出“都都英语”，允许麦克风功能使用<br><br>

                                <strong>2. Android机型 ：</strong><br>
                                打开手机上的“设置”> “应用” > “应用管理”， 其中找到“都都英语”， 请允许麦克风功能权限
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>运行慢，有时会卡顿</h2>
                        <div class="text">
                            <p>
                                如果之前能够正常使用， <br>
                                但突然开始有卡顿现象，可以试试关闭机器的电源并重启。<br>
                                <strong>重启完后还反复出现同样问题， 请确认机器中的内存是否足够：</strong><br><br>

                                <strong>1. iOS机型：</strong><br>
                                打开“设置”> “通用” > “储存空间”， 剩余空间500M以上才能保证正常运行<br><br>

                                <strong>2. Android机型：</strong><br>
                                打开“设置”> “手机信息” > “储存空间”， 剩余空间500M以上才能保证正常运行
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>应用一直闪退或不能启动</h2>
                        <div class="text">
                            <p>
                                应用不能正常使用有多种原因，其中三大类原因如下：<br><br>

                                <strong>1. 软件版本过低</strong><br>

                                <strong>&gt; iOS机型 ：</strong><br>
                                打开“设置”> “关于本机”> 确认软件版本是否最新， 如果有更新提示，请进行更新，<br>
                                详细内容请查看：<a href="https://support.apple.com/zh-cn/ios/update" target="_blank">https://support.apple.com/zh-cn/ios/update</a><br>
                                <strong>&gt; Android机型 ：</strong><br>
                                打开设置>关于手机> 软件手动更新， 可查看软件版本信息，如果有更新提示，请进行更新，<br>
                                详细内容请查看：<a href="https://support.google.com/android/answer/7680439" target="_blank">https://support.google.com/android/answer/7680439</a><br><br>

                                <strong>2. 都都英语版本过低</strong><br>
                                请在应用商店中找出都都英语， 如果有更新提示，请进行更新<br><br>

                                <strong>3. 机器临时不正常运行</strong><br>
                                请关机，重启后尝试<br><br>

                                如果以上解答解决不了您的问题，请联系官方客服QQ:2179916770

                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>付款了但显示没有购买</h2>
                        <div class="text">
                            <p>
                                请确认是否以付款时登陆的账号在登录， 我们支持邮箱登录和Apple账号登录， <br>
                                如果想不起来当时的登录账号请联系官方客服QQ:2179916770<br>
                                如果以Apple账号登录， 有时候会被切换成另一个账号， 这种情况也请联系客服，谢谢
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>无法退出</h2>
                        <div class="text">
                            <p>
                                如果使用Apple账号登录了， 于应用中无法退出，需要在Apple设置中进行退出：<br><br>

                                打开Apple设备中的“设置”>选择Apple账号>密码与安全性>使用您Apple ID的App> 找到都都英语进行退出
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>如何退款</h2>
                        <div class="text">
                            <p>
                                根据Apple的政策，退款请联系Apple客服电话: 400-666-8800
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>Android版本</h2>
                        <div class="text">
                            <p>
                                您可以在中国大陆下载Android版本。<br>
                                请在小米，华为、OPPO、VIVO、联想、应用宝应用商店，搜索“都都英语”下载使用。
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>存档如何同步</h2>
                        <div class="text">
                            <p>
                                请使用同一个邮箱的都都英语账号登陆在不同的设备，存档会自动同步
                            </p>
                        </div>
                    </li>

                    <li class="item">
                        <h2 class="accordionTitle" v-on:click="handleClickTitle">
                            <span class="accIcon"></span>想了解服务条款和隐私政策</h2>
                        <div class="text">
                            <p>
                                都都英语的服务条款和隐私政策描述了美国Enuma总部的规则，职责和原则。<br>
                                需要您同意才能注册使用都都英语的内容。 请在以下链接中查看更多详细信息，感谢！<br>
                                1）服务条款>> <span class='link' @click='handleClickLink("tos")'>http://enuma.com/tos/</span><br>
                                2）收集和使用个人信息（隐私政策）>> <span class='link' @click='handleClickLink("policy")'>http://enuma.com/policy/</span>
                            </p>
                        </div>
                    </li>

                </ul>
            </div>

    </div>
</template>
<script>

export default {
    name: 'faq',
    mounted() {
        var item = document.querySelectorAll('.item')
        for(var i=0; i<item.length; i++) {
            item[i].setAttribute( 'position', item[i].getBoundingClientRect().top )
        }
    },
    data() {
        return {
            selectedTitle: null,
        }
    },
    methods: {
        handleClickTitle(event) {
            if (this.selectedTitle != null) {
                this.selectedTitle.classList.remove('show')
                this.selectedTitle.querySelector('span').classList.remove('selected')
                this.selectedTitle.parentNode.querySelector('.text').classList.remove('show')

                if (this.selectedTitle == event.currentTarget) {
                    this.selectedTitle = null
                    return
                }
            }

            this.selectedTitle = event.currentTarget
            this.selectedTitle.classList.add('show')
            this.selectedTitle.querySelector('span').classList.add('selected')
            this.selectedTitle.parentNode.querySelector('.text').classList.add('show')

            window.scrollTo({left:0, top:this.selectedTitle.parentNode.getAttribute('position'), behavior:'smooth'})
        },
        handleClickLink(page) {
            this.$router.push('/frame/'+page)
        }
    }
}
</script>
<style src="@/assets/help/help.css" scoped></style>
<style scoped>
.top {
    position: absolute;
    width: 100%;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
}
.bold {
    font-weight: 600;
}

.title {
    font-size: 36px;
    margin-bottom: 12px !important;
}

.accordionTitle {
    font-size: 22px;
    margin-bottom: 10px;
    padding-bottom: 0px;
}

.accIcon {
    width: 30px;
    height: 30px;
}
.link {
    cursor: pointer;
    text-decoration: underline;
    color: #f7419c;
}

.content ul li p {
    font-size: 16px;
    line-height: 36px;
}

#topMenuBG {
    position: absolute;
    width: 100%;
    height: 0%;
    background-color: #000000;
    opacity: 0.3;
    display: none;
    z-index: 1;
}
@media screen and (max-width: 720px) {
    #topMenuBG {
        z-index: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/help/Faq.vue